// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop__MBTRF","showOff":"backdrop_showOff__7ECxS"};